<template lang="pug">
  div
    a-affix(
      :offsetTop="45"
      @change="handleFullViewModeSwitchAffixed"
    )
      a-row.mt-4
        a-col.py-2.text-center.border.bg-light(
          :xs="{span: 24}"
          :sm="{span: 10, offset: 14}"
          :lg="{span: 6, offset: 18}"
          :xl="{span: 5, offset: 19}"
          :class="{ 'shadow-sm': fullViewModeSwitchAffixed}"
        )
          full-view-mode-switch
    a-row.mt-4.mb-5
      a-col
        project-group-list
</template>

<script>
import { mapState } from 'vuex';

import ProjectGroupList from '@/components/ProjectGroupList';
import FullViewModeSwitch from '@/components/FullViewModeSwitch';

export default {
  components: {
    ProjectGroupList,
    FullViewModeSwitch,
  },
  data() {
    return {
      fullViewModeSwitchAffixed: false,
    };
  },
  computed: {
    ...mapState([
      'projectSearchText',
    ]),
  },
  methods: {
    handleFullViewModeSwitchAffixed(affixed) {
      this.fullViewModeSwitchAffixed = affixed;
    },
  },
};
</script>
